import { defineMessages } from 'react-intl';

export default defineMessages({
  visitDetails: {
    id: 'repvisits.calendar.availability.visitDetails',
    defaultMessage: 'Visit Details',
  },
  fairDetails: {
    id: 'repvisits.calendar.availability.fairDetails',
    defaultMessage: 'College Fair Details',
  },
  collegeFair: {
    id: 'common.collegeFair',
    defaultMessage: 'College Fair',
  },
  contact: {
    id: 'common.contact',
    defaultMessage: 'Contact',
  },
  date: {
    id: 'common.date',
    defaultMessage: 'Date',
  },
  time: {
    id: 'common.time',
    defaultMessage: 'Time',
  },
  school: {
    id: 'common.school',
    defaultMessage: 'High School',
  },
  schoolVisit: {
    id: 'common.schoolVisit',
    defaultMessage: 'High School Visit',
  },
  schoolPersonalVisit: {
    id: 'common.schoolPersonalVisit',
    defaultMessage: 'In-Person Visit',
  },
  schoolVirtualVisit: {
    id: 'common.schoolVirtualVisit',
    defaultMessage: 'Virtual Visit',
  },
  location: {
    id: 'common.location',
    defaultMessage: 'Location',
  },
  notes: {
    id: 'repvisits.calendar.availability.notes',
    defaultMessage: 'Notes',
  },
  internalNotes: {
    id: 'repvisits.calendar.availability.internalNotes',
    defaultMessage: 'Internal Notes',
  },
  instructions: {
    id: 'repvisits.calendar.availability.instructions',
    defaultMessage: 'Instructions from High School',
  },
  cost: {
    id: 'repvisits.calendar.availability.cost',
    defaultMessage: 'Cost',
  },
  expectedstudents: {
    id: 'repvisits.calendar.availability.expectedstudents',
    defaultMessage: 'Number of Expected Students',
  },
  rescheduleTitle: {
    id: 'repvisits.event.visit.rescheduleTitle',
    defaultMessage: 'Reschedule Availability',
  },
  reschedulePolicy: {
    id: 'repvisits.event.visit.reschedulePolicy',
    defaultMessage: 'This school allows you to reschedule visits up to {days} days before the event. ',
  },
  rescheduleLink: {
    id: 'repvisits.event.visit.reschedule',
    defaultMessage: 'Reschedule this visit',
  },
  title: {
    id: 'community.availabilitySidebar.title',
    defaultMessage: 'Repvisits Availability',
  },
  prevWeek: {
    id: 'repvisits.search.prevWeek',
    defaultMessage: 'Previous week',
  },
  nextWeek: {
    id: 'repvisits.search.nextWeek',
    defaultMessage: 'Next week',
  },
  showingWeek: {
    id: 'community.availabilitySidebar.showingWeek',
    defaultMessage: 'Showing week: ',
  },
  selectWeek: {
    id: 'community.availabilitySidebar.goToDate',
    defaultMessage: 'Go to date',
  },
});
